import { ReactNode, useRef } from "react";
import { ContentChannel, useContentChannel } from "./ContentChannel";
import { BreadcrumbItems } from "./Breadcrumbs/BreadcrumbItems";
import { useLayout } from "../ContentLayout";
import styles from "./ActionBars.module.css";

/** Displays the shell top action bars. */
export const ActionBars = (): ReactNode => {
  const actionBars = useContentChannel(null, "app-action-bars");
  const actionBarContainerRef = useRef<HTMLDivElement | null>(null);
  const layoutType = useLayout();

  if (actionBars.length === 0 || layoutType.startsWith("fullscreen")) return null;

  return (
    <div data-testid="actionbar" className={styles.root}>
      <div ref={actionBarContainerRef} className="bar-container">
        <ContentChannel id="app-action-bars">
          {(children, index): JSX.Element => (
            <div key={index} className="bar">
              {index === 0 && <BreadcrumbItems />}
              <div className="content">{children}</div>
            </div>
          )}
        </ContentChannel>
      </div>
    </div>
  );
};
